import I18n from 'I18n';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import AssetEditorLink from 'personalization-lib/components/shared/links/AssetEditorLink';
import VariantGenerationSuccessAlertBody from 'personalization-lib/components/alerts/VariantGenerationSuccessAlertBody';
import TruncateInlineString from 'personalization-lib/components/shared/display/TruncateInlineString';
import { CREATE_MODES } from 'personalization-lib/constants/variantCreation';
import { jsx as _jsx } from "react/jsx-runtime";
export const showSuccessAlert = options => FloatingAlertStore.addAlert(Object.assign({
  type: 'success'
}, options));
export const showErrorAlert = options => FloatingAlertStore.addAlert(Object.assign({
  titleText: I18n.text('personalizationLib.shared.alerts.error.title'),
  type: 'danger'
}, options));
export const showInfoAlert = options => FloatingAlertStore.addAlert(Object.assign({
  type: 'info'
}, options));
export const showOpenPanelErrorAlert = () => showErrorAlert({
  titleText: undefined,
  message: I18n.text('personalizationLib.shared.alerts.panelError.message')
});
export const showOpenModalErrorAlert = () => showErrorAlert({
  titleText: undefined,
  message: I18n.text('personalizationLib.shared.alerts.modalError.message')
});
export const showGenerateVariantInfoAlert = () => showInfoAlert({
  titleText: I18n.text('personalizationLib.createVariantPanel.alerts.create.withAI.success.title'),
  message: I18n.text('personalizationLib.createVariantPanel.alerts.create.withAI.success.message'),
  timeout: 5000
});
export const showCreateVariantSuccessAlert = assetInfo => showSuccessAlert({
  titleText: I18n.text('personalizationLib.createVariantPanel.alerts.create.manually.success.title'),
  'data-test-id': 'create-variant-success-alert',
  message: /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "personalizationLib.createVariantPanel.alerts.create.manually.success.message",
    options: {
      editorLink: /*#__PURE__*/_jsx(AssetEditorLink, Object.assign({}, assetInfo))
    }
  }),
  timeout: 5000
});
export const showCreateVariantErrorAlert = mode => {
  if (mode === CREATE_MODES.MANUAL) {
    showErrorAlert({
      message: I18n.text('personalizationLib.createVariantPanel.alerts.create.manually.error')
    });
  }
  if (mode === CREATE_MODES.WITH_AI) {
    showErrorAlert({
      message: I18n.text('personalizationLib.createVariantPanel.alerts.create.withAI.error')
    });
  }
};
export const showContentEditorCreateVariantSuccessAlert = () => showSuccessAlert({
  message: I18n.text('personalizationLib.contentEditor.alerts.manual.success'),
  timeout: 5000
});

/** Shows alert for variant generation success. If no asset coordinates are passed, no button will appear in the alert and it will timeout faster. */
export const showVariantGenerationSuccessAlert = assetInfo => showSuccessAlert({
  message: /*#__PURE__*/_jsx(VariantGenerationSuccessAlertBody, Object.assign({}, assetInfo)),
  timeout: assetInfo.assetCoordinates ? 15000 : undefined
});
export const showVariantGenerationErrorAlert = assetInfo => showErrorAlert({
  message: /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "personalizationLib.contentEditor.alerts.aiGeneration.error",
    options: {
      variantName: /*#__PURE__*/_jsx(TruncateInlineString, {
        text: assetInfo.assetName
      })
    }
  })
});
export const showFetchWebVisitorPropertiesErrorAlert = () => showErrorAlert({
  titleText: I18n.text('personalizationLib.shared.errors.fetchWebVisitorProperties.title'),
  message: I18n.text('personalizationLib.shared.errors.fetchWebVisitorProperties.message')
});
export const showPreviewStrategyErrorAlert = () => showErrorAlert({
  titleText: I18n.text('personalizationLib.shared.errors.previewStrategy.title'),
  message: I18n.text('personalizationLib.shared.errors.previewStrategy.message')
});